import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { StudentsPageRoutingModule } from './students-routing.module';
import { OpenFormComponentModule } from 'src/app/component/open-form/open-form.component.module';
import { DxDataGridModule } from 'devextreme-angular';
import { StudentsPage } from './students.page';
import { StudentsService } from './service/students.service';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		IonicModule,
		StudentsPageRoutingModule,
		DxDataGridModule,
		OpenFormComponentModule,
	],
	declarations: [StudentsPage],
	providers: [StudentsService],
})
export class StudentsPageModule {}
